(function () {
  document.addEventListener(
    "click",
    function (e) {
      var trigger = e.target.closest("[data-cart-toggle]");
      if (!trigger) return;
      var drawer = document.querySelector("cart-drawer");
      if (!drawer || drawer.classList.contains("is-open")) return;
      drawer.classList.add("is-open");
    },
    true
  );

  function syncCheckoutTotal() {
    var moneyEl = document.querySelector("[data-checkout-money]");
    if (!moneyEl) return;
    var money = moneyEl.textContent.replace(/\s+/g, " ").trim();
    document.querySelectorAll("[data-checkout-total]").forEach(function (el) {
      el.textContent = money;
    });
  }

  document.addEventListener("theme:cart:change", function () {
    requestAnimationFrame(syncCheckoutTotal);
  });

  document.addEventListener("DOMContentLoaded", syncCheckoutTotal);
})();
